// eslint-disable-next-line @typescript-eslint/naming-convention
export var ISO8601Brand;
(function (ISO8601Brand) {
    ISO8601Brand["_"] = "";
})(ISO8601Brand || (ISO8601Brand = {}));
// eslint-disable-next-line @typescript-eslint/naming-convention
export var ISO4217Brand;
(function (ISO4217Brand) {
    ISO4217Brand["_"] = "";
})(ISO4217Brand || (ISO4217Brand = {}));
export var ECurrencyPairBrand;
(function (ECurrencyPairBrand) {
    ECurrencyPairBrand["_"] = "";
})(ECurrencyPairBrand || (ECurrencyPairBrand = {}));
export var ECcyPairBrand;
(function (ECcyPairBrand) {
    ECcyPairBrand["_"] = "";
})(ECcyPairBrand || (ECcyPairBrand = {}));
